export default __webpack_public_path__ + "static/mar-email-campaign-fe296959c9fb7a6d72a46c8b3942dbb4.png";